export default __webpack_public_path__ + "static/assets/NunitoRegular.707dfaa7.woff";